import { CompanyPaymentReports } from '../modules/finance/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
export function CompanyPaymentReportsScreen() {
  const { can, company, today } = useCompanyScope();
  const unit = company.businessUnits?.find((u) => u.id === company.activeBusinessUnitId);
  return (
    <GatedCompanyScreen allowed={can('financial_reports.read')}>
      <CompanyPaymentReports
        key={unit?.id ?? 'all'}
        today={today}
        unitName={unit?.displayName ?? null}
        canImport={Boolean(unit) && can('financial_reports.import')}
        canConfigure={Boolean(unit) && can('financial_reports.settings.manage')}
        canCancel={Boolean(unit) && can('financial_reports.cancel')}
      />
    </GatedCompanyScreen>
  );
}
